import type { ProfileResponse, ProfileSort } from '@shared/schemas';

import type { FilterGroup } from '@/types/filters';

/** Rows per page, matching the original `useInfiniteApi('/profiles?favorite=true', 25)`. */
export const DEFAULT_PAGE_SIZE = 25;

/**
 * Redux state for the Tracked LPs list. Server-side pagination + filtering over
 * the favourites scope: current page's rows, grand `total`, load lifecycle
 * (`error` is a banner message; `loaded` turns true with the first successful
 * fetch, so the empty state never shows before an answer), 0-indexed `page` / `pageSize`, the pruned
 * `filters` and the `sort` (null = the server's name order, #710) that drive the fetch. Un-favoriting removes the row optimistically
 * (a pure `rowRemoved` transition) before the saga reconciles with the server.
 * Filter-bar edit state, column config and row selection stay local to the page.
 */
export interface TrackedLpsState {
  rows: ProfileResponse[];
  total: number;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  page: number;
  pageSize: number;
  filters: FilterGroup | null;
  sort: ProfileSort | null;
}

export const initialState: TrackedLpsState = {
  rows: [],
  total: 0,
  loading: false,
  loaded: false,
  error: null,
  page: 0,
  pageSize: DEFAULT_PAGE_SIZE,
  filters: null,
  sort: null,
};
